(function () {
  window.WoodarqCustomerReviews = window.WoodarqCustomerReviews || {};

  if (window.WoodarqCustomerReviews.__booted) {
    if (typeof window.WoodarqCustomerReviews.initAll === 'function') {
      window.WoodarqCustomerReviews.initAll(document);
    }
    return;
  }

  window.WoodarqCustomerReviews.__booted = true;

  var ROOT_SELECTOR = '[data-woodarq-customer-reviews]';
  var TOP_REVEAL_SELECTOR = '.jdgm-rev-widg__title, .jdgm-row-stars, .jdgm-row-actions';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function removeInlineDisplayNone(el) {
    if (!el || !el.style) return;
    if (el.style.display === 'none') el.style.display = '';
    if (el.style.visibility === 'hidden') el.style.visibility = '';
    if (el.style.opacity === '0') el.style.opacity = '';
  }

  function normalizeSummaryText(root) {
    var summaryText = root.querySelector('.jdgm-rev-widg__summary-text');
    if (!summaryText) return;

    var text = (summaryText.textContent || '').trim();
    if (!text) return;

    text = text
      .replace(/based on/i, 'Based on')
      .replace(/\breviews\b/i, 'Reviews')
      .replace(/\breview\b/i, 'Review');

    if (summaryText.textContent.trim() !== text) summaryText.textContent = text;
  }

  function normalizeWriteButton(root) {
    var writeLink = root.querySelector('.jdgm-write-rev-link');
    if (!writeLink) return;

    removeInlineDisplayNone(writeLink);

    // Keep the label stable without replacing the anchor on every Judge.me
    // mutation. Replacing its contents repeatedly can race with Judge.me's own
    // click/setup logic, which is what made the first click feel dead on PDP.
    if ((writeLink.textContent || '').trim() !== 'Write a Review') {
      writeLink.textContent = 'Write a Review';
    }

    writeLink.setAttribute('aria-label', 'Write a Review');
    writeLink.setAttribute('role', 'button');
  }

  function isLegacyReviewFormWrapper(formWrapper) {
    return !!(formWrapper && formWrapper.closest && formWrapper.closest('.jdgm-legacy-widget-content'));
  }

  function findReviewFormWrapper(root) {
    if (!root) return null;

    var wrappers = toArray(root.querySelectorAll('.jdgm-form-wrapper, .jdgm-write-rev-form, .jdgm-rev-widg__form'));
    return wrappers.find(function (formWrapper) {
      return !isLegacyReviewFormWrapper(formWrapper);
    }) || null;
  }

  function findReviewFormWrappers(scope) {
    return toArray((scope || document).querySelectorAll('.jdgm-form-wrapper, .jdgm-write-rev-form, .jdgm-rev-widg__form')).filter(function (formWrapper) {
      return !isLegacyReviewFormWrapper(formWrapper);
    });
  }

  function findReviewRootFromForm(formWrapper) {
    if (!formWrapper || !formWrapper.closest) return null;
    return formWrapper.closest(ROOT_SELECTOR) || document.querySelector(ROOT_SELECTOR);
  }

  function isInlineHidden(el) {
    if (!el) return true;
    var inlineDisplay = el.style && el.style.display;
    var inlineVisibility = el.style && el.style.visibility;

    return inlineDisplay === 'none' || inlineVisibility === 'hidden' || el.getAttribute('aria-hidden') === 'true';
  }

  function isVisuallyOpen(el) {
    if (!el) return false;
    if (isInlineHidden(el)) return false;

    if (window.getComputedStyle) {
      var style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    }

    return true;
  }



  function getClosestFieldset(el) {
    if (!el || !el.closest) return null;
    return el.closest('.jdgm-form__fieldset, .jdgm-form__field');
  }

  function normalizeReviewerNameFormatUI(formWrapper) {
    if (!formWrapper) return;

    toArray(formWrapper.querySelectorAll('.jdgm-form__reviewer-name-format-container')).forEach(function (container) {
      var fieldset = getClosestFieldset(container);
      var select = container.querySelector('select[name="reviewer_name_format"], select[id*="reviewer_name_format"]');
      var dropdownWrapper = select && select.closest ? select.closest('.jdgm-sort-dropdown-wrapper') : null;

      container.classList.add('woodarq-review-name-format');
      if (fieldset) fieldset.classList.add('woodarq-jdgm-name-fieldset');
      if (select) select.setAttribute('aria-label', 'Choose how your display name appears publicly');

      // Judge.me renders this text as loose text nodes with parentheses around an
      // inline select. Rebuild only this helper line so it reads naturally and the
      // select stays compact instead of becoming the oversized dropdown in the screenshot.
      if (select && dropdownWrapper && !container.__waNameFormatRebuilt) {
        var helperText = document.createElement('span');
        helperText.className = 'woodarq-review-name-format__text';
        helperText.textContent = 'Displayed publicly as';

        container.textContent = '';
        container.appendChild(helperText);
        container.appendChild(dropdownWrapper);
        container.__waNameFormatRebuilt = true;
      }
    });
  }

  function isPotentialNativeMediaElement(el) {
    if (!el) return false;

    var text = [
      el.className || '',
      el.id || '',
      el.getAttribute && (el.getAttribute('name') || ''),
      el.getAttribute && (el.getAttribute('data-field') || ''),
      el.getAttribute && (el.getAttribute('data-type') || ''),
      el.getAttribute && (el.getAttribute('aria-label') || '')
    ].join(' ').toLowerCase();

    return /picture|photo|image|video|media|upload|youtube/.test(text);
  }

  function decorateNativeReviewMediaFields(formWrapper) {
    if (!formWrapper) return false;

    var mediaSelectors = [
      'input[type="file"]',
      'input[name*="picture"]',
      'input[name*="photo"]',
      'input[name*="image"]',
      'input[name*="video"]',
      'input[name*="media"]',
      'textarea[name*="youtube"]',
      'input[name*="youtube"]',
      '.jdgm-picture-fieldset',
      '.jdgm-media-fieldset',
      '.jdgm-upload-fieldset',
      '.jdgm-form__fieldset--picture',
      '.jdgm-form__fieldset--media',
      '.jdgm-form__fieldset--upload',
      '[class*="picture"]',
      '[class*="photo"]',
      '[class*="video"]',
      '[class*="media"]',
      '[class*="upload"]',
      '[data-media-upload]',
      '[data-picture-upload]',
      '[data-video-upload]'
    ].join(',');

    var candidates = toArray(formWrapper.querySelectorAll(mediaSelectors)).filter(function (el) {
      if (el.matches && el.matches('.jdgm-legacy-widget-content, .jdgm-legacy-widget-content *')) return false;
      return isPotentialNativeMediaElement(el) || (el.matches && el.matches('input[type="file"]'));
    });

    if (!candidates.length) return false;

    candidates.forEach(function (field) {
      var fieldset = getClosestFieldset(field) || field.parentElement;
      var wrapper = fieldset || field;

      if (wrapper && wrapper.classList) {
        wrapper.classList.add('woodarq-review-media-fieldset', 'woodarq-review-native-media-fieldset');
        removeInlineDisplayNone(wrapper);
      }

      removeInlineDisplayNone(field);

      if (field.querySelectorAll) {
        toArray(field.querySelectorAll('input[type="file"], input, textarea, button, label')).forEach(removeInlineDisplayNone);
      }

      var type = (field.getAttribute && field.getAttribute('type') || '').toLowerCase();
      if (type === 'file') {
        field.classList.add('woodarq-review-media-input');
        field.setAttribute('accept', field.getAttribute('accept') || 'image/*,video/*');
      }
    });

    return true;
  }

  function updateReviewMediaFilesLabel(input, label) {
    if (!input || !label) return;

    var files = toArray(input.files);
    if (!files.length) {
      label.textContent = 'No media selected yet';
      return;
    }

    label.textContent = files.map(function (file) { return file.name; }).join(', ');
  }

  function getReviewRatingScore(star) {
    if (!star) return 0;

    var rawScore = star.getAttribute('data-alt') || star.getAttribute('aria-label') || star.getAttribute('title') || '';
    var match = String(rawScore).match(/\d+/);
    var score = match ? parseInt(match[0], 10) : 0;

    return Number.isFinite(score) ? score : 0;
  }

  function applyReviewRating(star) {
    if (!star) return;

    var rating = star.closest ? star.closest('.jdgm-form__rating') : null;
    if (!rating) return;

    var score = getReviewRatingScore(star);
    if (!score) return;

    var hiddenInput = rating.querySelector('input[name="score"]');
    if (hiddenInput) {
      hiddenInput.value = String(score);
      hiddenInput.setAttribute('value', String(score));

      try { hiddenInput.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
      try { hiddenInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }

    toArray(rating.querySelectorAll('.jdgm-star')).forEach(function (ratingStar) {
      var ratingStarScore = getReviewRatingScore(ratingStar);
      var isSelected = ratingStarScore <= score;

      ratingStar.classList.toggle('jdgm--on', isSelected);
      ratingStar.classList.toggle('jdgm--off', !isSelected);
      ratingStar.classList.remove('jdgm--half');
      ratingStar.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function hardenReviewRatingStar(star) {
    if (!star) return;

    var score = getReviewRatingScore(star);

    // Judge.me renders the rating stars as <a> elements. The theme's Taxi/page
    // transition script delegates clicks to every anchor that does not have an
    // href beginning with #. If the rating anchor has no href, Taxi treats it as
    // the shop root and sends the customer back to the home page on desktop.
    // Keep a harmless hash href on the star and explicitly opt it out of Taxi.
    star.setAttribute('href', '#judgeme_product_reviews');
    star.setAttribute('data-taxi-ignore', 'true');
    star.setAttribute('role', 'button');
    star.setAttribute('tabindex', '0');

    if (score) {
      star.setAttribute('aria-label', score + (score === 1 ? ' star' : ' stars'));
    }
  }

  function normalizeReviewRatingLinks(formWrapper) {
    if (!formWrapper) return;

    toArray(formWrapper.querySelectorAll('.jdgm-form__rating .jdgm-star')).forEach(hardenReviewRatingStar);
  }

  function getReviewRatingStarFromEvent(event) {
    if (!event || !event.target || !event.target.closest) return null;

    // Judge.me may inject the form inside the section or temporarily move it in
    // the DOM while opening it. Catch the actual form stars wherever they are.
    return event.target.closest('.jdgm-form__rating .jdgm-star');
  }

  function sanitizeReviewRatingStarEvent(event) {
    var star = getReviewRatingStarFromEvent(event);
    if (!star) return null;

    hardenReviewRatingStar(star);
    return star;
  }

  function handleReviewRatingStarClick(event) {
    var star = sanitizeReviewRatingStarEvent(event);
    if (!star) return;

    if (event.cancelable !== false) event.preventDefault();
    applyReviewRating(star);

    // Re-apply after Judge.me's own handler has had a chance to run so the
    // visible star state and hidden score stay in sync without causing navigation.
    window.setTimeout(function () {
      applyReviewRating(star);
    }, 0);
  }

  function handleReviewRatingStarKeydown(event) {
    var star = sanitizeReviewRatingStarEvent(event);
    if (!star) return;

    var key = event.key || event.code;
    if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar') return;

    if (event.cancelable !== false) event.preventDefault();
    applyReviewRating(star);
  }

  function ensureReviewMediaUpload(formWrapper) {
    if (!formWrapper) return;

    var form = formWrapper.querySelector('form');
    if (!form) return;

    // Do not add a fake file input. Judge.me will only attach media to the
    // submitted review when its own native uploader is present. The section now
    // uses Judge.me's current Review Widget install code so the app can mount
    // that native uploader from review_widget_data. This function only styles
    // and unhides native Judge.me media fields after they are injected.
    form.setAttribute('enctype', 'multipart/form-data');
    decorateNativeReviewMediaFields(formWrapper);
  }

  function normalizeReviewFormFields(formWrapper) {
    if (!formWrapper) return;

    if (formWrapper.__waReviewFormFieldsNormalized) {
      normalizeReviewerNameFormatUI(formWrapper);
      normalizeReviewRatingLinks(formWrapper);
      ensureReviewMediaUpload(formWrapper);
      return;
    }

    var form = formWrapper.querySelector('form');
    if (form) {
      form.setAttribute('autocomplete', 'off');
    }

    toArray(formWrapper.querySelectorAll('input, textarea, select')).forEach(function (field) {
      var tagName = (field.tagName || '').toLowerCase();
      var type = (field.getAttribute('type') || '').toLowerCase();
      var name = (field.getAttribute('name') || '').toLowerCase();
      var id = (field.getAttribute('id') || '').toLowerCase();

      if (type === 'hidden' || type === 'submit' || type === 'button' || type === 'checkbox' || type === 'radio') return;

      if (tagName === 'textarea') {
        field.setAttribute('autocomplete', 'off');
        field.setAttribute('spellcheck', 'true');
        return;
      }

      if (type === 'file') {
        field.setAttribute('accept', field.getAttribute('accept') || 'image/*,video/*');
        field.setAttribute('autocomplete', 'off');
        return;
      }

      // Keep browser autofill popovers from making the Judge.me name field look
      // like a separate broken dropdown in the middle of the form.
      if (name.indexOf('name') !== -1 || id.indexOf('name') !== -1) {
        field.setAttribute('autocomplete', 'off');
        field.setAttribute('autocorrect', 'off');
        field.setAttribute('autocapitalize', 'words');
        field.setAttribute('spellcheck', 'false');
      } else if (type === 'email' || name.indexOf('email') !== -1 || id.indexOf('email') !== -1) {
        field.setAttribute('autocomplete', 'email');
        field.setAttribute('inputmode', 'email');
      } else {
        field.setAttribute('autocomplete', 'off');
      }
    });

    normalizeReviewerNameFormatUI(formWrapper);
    normalizeReviewRatingLinks(formWrapper);
    ensureReviewMediaUpload(formWrapper);

    formWrapper.__waReviewFormFieldsNormalized = true;
  }

  function normalizeReviewFormWrapperDirect(formWrapper, forceOpen) {
    if (!formWrapper) return false;

    formWrapper.classList.add('woodarq-jdgm-form-wrapper');
    normalizeReviewFormFields(formWrapper);

    formWrapper.style.position = 'relative';
    formWrapper.style.top = 'auto';
    formWrapper.style.right = 'auto';
    formWrapper.style.bottom = 'auto';
    formWrapper.style.left = 'auto';
    formWrapper.style.transform = 'none';

    var root = findReviewRootFromForm(formWrapper);

    if (forceOpen || isVisuallyOpen(formWrapper)) {
      formWrapper.classList.add('woodarq-jdgm-form-open');
      if (forceOpen) {
        formWrapper.style.display = 'block';
        formWrapper.style.visibility = 'visible';
        formWrapper.style.opacity = '';
        formWrapper.removeAttribute('aria-hidden');
      }
      if (root) root.classList.add('woodarq-review-form-is-open');
    }

    return true;
  }

  function normalizeAllReviewForms(scope, forceOpen) {
    findReviewFormWrappers(scope || document).forEach(function (formWrapper) {
      normalizeReviewFormWrapperDirect(formWrapper, forceOpen);
    });
  }

  function normalizeReviewForm(root, forceOpen) {
    var formWrapper = findReviewFormWrapper(root);
    if (!formWrapper) return false;

    var actions = root.querySelector('.jdgm-row-actions, .jdgm-widget-actions-wrapper');

    // Judge.me can inject/reposition the form after the review list. Keep it
    // directly under the review controls so opening the form does not create a
    // mysterious blank gap at the bottom of the page.
    if (actions && formWrapper.parentElement !== actions.parentElement) {
      actions.insertAdjacentElement('afterend', formWrapper);
    }

    formWrapper.classList.add('woodarq-jdgm-form-wrapper');
    normalizeReviewFormFields(formWrapper);
    formWrapper.style.position = 'relative';
    formWrapper.style.top = 'auto';
    formWrapper.style.right = 'auto';
    formWrapper.style.bottom = 'auto';
    formWrapper.style.left = 'auto';
    formWrapper.style.transform = 'none';

    if (forceOpen) {
      formWrapper.classList.add('woodarq-jdgm-form-open');
      formWrapper.style.display = 'block';
      formWrapper.style.visibility = 'visible';
      formWrapper.style.opacity = '';
      formWrapper.removeAttribute('aria-hidden');
      root.classList.add('woodarq-review-form-is-open');
      root.__waReviewFormRequested = false;
      return true;
    }

    if (isVisuallyOpen(formWrapper)) {
      formWrapper.classList.add('woodarq-jdgm-form-open');
      root.classList.add('woodarq-review-form-is-open');
    } else {
      formWrapper.classList.remove('woodarq-jdgm-form-open');
      root.classList.remove('woodarq-review-form-is-open');
    }

    return true;
  }

  function focusReviewForm(root) {
    var formWrapper = findReviewFormWrapper(root);
    if (!formWrapper || !formWrapper.classList.contains('woodarq-jdgm-form-open')) return;

    var focusTarget = formWrapper.querySelector('input:not([type=hidden]), textarea, select, button');

    if (formWrapper.scrollIntoView) {
      formWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    if (focusTarget && focusTarget.focus) {
      window.setTimeout(function () {
        try { focusTarget.focus({ preventScroll: true }); }
        catch (e) { focusTarget.focus(); }
      }, 220);
    }
  }

  function openReviewFormFromButton(button) {
    var root = button && button.closest ? button.closest(ROOT_SELECTOR) : null;
    if (!root) return;

    root.__waReviewFormRequested = true;

    // Let Judge.me run first, then apply a small fallback if its lazy-loaded
    // form was not opened by the initial click yet.
    window.setTimeout(function () {
      if (normalizeReviewForm(root, true)) focusReviewForm(root);
      normalizeAllReviewForms(document, false);
    }, 90);

    window.setTimeout(function () {
      if (normalizeReviewForm(root, true)) focusReviewForm(root);
      normalizeAllReviewForms(document, false);
    }, 360);

    window.setTimeout(function () {
      normalizeAllReviewForms(document, false);
    }, 900);
  }

  function moveVerifiedBadge(review) {
    var ratingRow = review.querySelector('.jdgm-row-rating');
    var badgeWrapper = review.querySelector('.jdgm-rev__buyer-badge-wrapper');
    var badge = review.querySelector('.jdgm-rev__buyer-badge');

    if (!ratingRow || !badgeWrapper) return;

    removeInlineDisplayNone(badgeWrapper);
    removeInlineDisplayNone(badge);

    if (badge && !badge.textContent.trim()) {
      badge.textContent = 'Verified';
    }

    if (badge && badge.textContent.trim().toLowerCase() !== 'verified') {
      badge.textContent = 'Verified';
    }

    if (!ratingRow.contains(badgeWrapper)) {
      ratingRow.appendChild(badgeWrapper);
    }
  }

  function prepareTopReveal(root) {
    toArray(root.querySelectorAll(TOP_REVEAL_SELECTOR)).forEach(function (el, index) {
      el.setAttribute('data-wa-review-top-reveal', '');
      el.style.setProperty('--wa-review-delay', index * 110 + 'ms');
    });
  }

  function prepareReviewCards(root) {
    var reviews = toArray(root.querySelectorAll('.jdgm-rev'));

    reviews.forEach(function (review, index) {
      moveVerifiedBadge(review);
      review.classList.add('wa-review-card');
      review.style.setProperty('--wa-review-delay', Math.min(index * 80, 240) + 'ms');

      if (!review.__waReviewObserverBound && window.__waReviewCardObserver) {
        window.__waReviewCardObserver.observe(review);
        review.__waReviewObserverBound = true;
      }
    });
  }

  function unlockJudgeMeInlineStyles(root) {
    var widget = root.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg');
    if (!widget) return;

    if (widget.style) {
      widget.style.maxWidth = '';
      widget.style.margin = '';
      widget.style.display = '';
      widget.style.padding = '';
    }

    toArray(root.querySelectorAll('.jdgm-rev-widg, .jdgm-widget-actions-wrapper, .jdgm-write-rev-link')).forEach(removeInlineDisplayNone);
  }


  function requestJudgeMeWidgetRender(root) {
    if (!root || root.__waJudgeMeRenderRequested) return;

    root.__waJudgeMeRenderRequested = true;

    window.setTimeout(function () {
      try {
        if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') window.jdgm.initializeWidgets();
        if (window.jdgm && typeof window.jdgm.renderWidgets === 'function') window.jdgm.renderWidgets();
        if (window.jdgm && typeof window.jdgm.refreshWidgets === 'function') window.jdgm.refreshWidgets();
        if (window.JDGM && typeof window.JDGM.init === 'function') window.JDGM.init();
      } catch (error) {}

      root.__waJudgeMeRenderRequested = false;
    }, 0);
  }

  function enhance(root) {
    if (!root) return;

    unlockJudgeMeInlineStyles(root);
    normalizeSummaryText(root);
    normalizeWriteButton(root);
    normalizeReviewForm(root, !!root.__waReviewFormRequested);
    normalizeAllReviewForms(root, !!root.__waReviewFormRequested);
    prepareTopReveal(root);
    prepareReviewCards(root);
  }

  function setupRootVisibility(root) {
    if (root.__waReviewRootObserverBound) return;
    root.__waReviewRootObserverBound = true;

    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-wa-review-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          root.classList.add('is-wa-review-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    observer.observe(root);
  }

  function setupCardObserver() {
    if (window.__waReviewCardObserver) return;

    if (!('IntersectionObserver' in window)) {
      window.__waReviewCardObserver = {
        observe: function (el) { el.classList.add('is-wa-review-visible'); },
        unobserve: function () {}
      };
      return;
    }

    window.__waReviewCardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-wa-review-visible');
          window.__waReviewCardObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
  }

  function initRoot(root) {
    if (!root) return;

    setupRootVisibility(root);
    requestJudgeMeWidgetRender(root);
    if (!root.__waJudgeMeRenderRetriesBound) {
      root.__waJudgeMeRenderRetriesBound = true;
      [250, 1000, 2400].forEach(function (delay) {
        window.setTimeout(function () { requestJudgeMeWidgetRender(root); }, delay);
      });
    }
    enhance(root);

    if (root.__waReviewsObserver) return;

    var debounceTimer;
    root.__waReviewsObserver = new MutationObserver(function () {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(function () {
        enhance(root);
      }, 60);
    });

    root.__waReviewsObserver.observe(root, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style', 'aria-expanded']
    });
  }

  function initAll(scope) {
    setupCardObserver();
    toArray((scope || document).querySelectorAll(ROOT_SELECTOR)).forEach(initRoot);
    normalizeAllReviewForms(scope || document, false);
  }

  window.WoodarqCustomerReviews.initAll = initAll;
  window.WoodarqCustomerReviews.initRoot = initRoot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAll(document);
  });

  if (!window.WoodarqCustomerReviews.__globalFormObserverBound && 'MutationObserver' in window) {
    window.WoodarqCustomerReviews.__globalFormObserverBound = true;
    var globalFormObserverTimer;
    var globalFormObserver = new MutationObserver(function (mutations) {
      var shouldNormalize = mutations.some(function (mutation) {
        if (mutation.type === 'attributes') {
          return mutation.target && mutation.target.matches && mutation.target.matches('.jdgm-form-wrapper, .jdgm-write-rev-form, .jdgm-rev-widg__form, .jdgm-form-wrapper *, .jdgm-write-rev-form *, .jdgm-rev-widg__form *');
        }

        return toArray(mutation.addedNodes).some(function (node) {
          return node && node.nodeType === 1 && (
            (node.matches && node.matches('.jdgm-form-wrapper, .jdgm-write-rev-form, .jdgm-rev-widg__form')) ||
            (node.querySelector && node.querySelector('.jdgm-form-wrapper, .jdgm-write-rev-form, .jdgm-rev-widg__form'))
          );
        });
      });

      if (!shouldNormalize) return;

      window.clearTimeout(globalFormObserverTimer);
      globalFormObserverTimer = window.setTimeout(function () {
        initAll(document);
        normalizeAllReviewForms(document, false);
      }, 40);
    });

    globalFormObserver.observe(document.documentElement, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style', 'aria-hidden']
    });
  }

  document.addEventListener('pointerdown', sanitizeReviewRatingStarEvent, true);
  document.addEventListener('mousedown', sanitizeReviewRatingStarEvent, true);
  document.addEventListener('touchstart', sanitizeReviewRatingStarEvent, true);
  document.addEventListener('click', handleReviewRatingStarClick, true);
  document.addEventListener('keydown', handleReviewRatingStarKeydown, true);

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest(ROOT_SELECTOR + ' .jdgm-write-rev-link') : null;
    if (!button) return;

    openReviewFormFromButton(button);
  }, false);
})();
